import { ConfirmDialog } from "components/shared";
import { Notification, toast } from "components/ui";
import { statusResponse } from "constants/apiResponse.constant";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { apiPutTicket } from "services/TicketsService";
import { deleteDuplicateData, showMessageError } from "utils/storeHube/helpers";
import { setSelectedTicket, updateTicketList } from "../store/dataSlice";
import { toggleChangeStatusConfirmation } from "../store/stateSlice";

const TicketChangeStatusConfitmation = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const dialogOpen = useSelector((state) => state.ticketList.state.changeStatusConfirmation)
    const { selectedTicketId, ticketList } = useSelector((state) => state.ticketList.data)
    const [loading, setLoading] = useState(false)

    const onDialogClose = () => {
        if (loading) return
        dispatch(toggleChangeStatusConfirmation(false))
    }

    const onChangeStatus = async () => {
        // No cerrar el modal antes del await: si la API falla el usuario
        // necesita ver el feedback y poder reintentar. Cerramos solo en
        // exito. Pase 26: fix loading state del flujo de cambio de estado.
        setLoading(true)
        try {
            const { status, data } = await apiPutTicket(selectedTicketId, { ticket_status_id: 2 })
            if (status === statusResponse.SUCCESS) {

                const newTicketList = deleteDuplicateData(ticketList, data.data)

                dispatch(updateTicketList(newTicketList))
                dispatch(setSelectedTicket(data.data))

                toast.push(
                    <Notification title={t('updated')} type="success" duration={4000}>
                        {t('ticket_successUpdate')}
                    </Notification>
                )

                dispatch(toggleChangeStatusConfirmation(false))
            }

        } catch (error) {
            showMessageError(error.response?.data?.message || error.message)
        } finally {
            setLoading(false)
        }
    }

    return (
        <ConfirmDialog
            isOpen={dialogOpen}
            onClose={onDialogClose}
            onRequestClose={onDialogClose}
            type="info"
            title={t('change_status')}
            onCancel={onDialogClose}
            onConfirm={onChangeStatus}
            confirmButtonColor="blue-600"
            cancelText={t('cancel_capitalize')}
            confirmText={t('confirm_capitalize')}
            confirmButtonLoading={loading}
        >
            <p>
                {t('change_status_label')}
            </p>
        </ConfirmDialog>
    )
}

export default TicketChangeStatusConfitmation